<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        OOO TEXT
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Text Message</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-if="user.role_id == 2"
                v-model="user.text_message"
                label="Callback message"
              ></v-textarea>
              <v-textarea
                v-else-if="user.role_id == 1"
                v-model="settings.default_text_message"
                label="Callback message"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="blue darken-1" @click="handleTextMassage" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "TextMessage",
  data() {
    return {
      open: false,
    };
  },
  methods: {
    ...mapMutations({
      setTextMessage: "auth/SET_TEXT_MESSAGE",
      setSettingsTextMessage: "auth/SET_DEFAULT_TEXT_MESSAGE",
    }),
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    handleTextMassage() {
      const role_id = this.user.role_id;
      if (role_id == 2) {
        this.setTextMessage(this.user.text_message);
        this.$axios
          .post("/user/update", {
            id: this.user.id,
            fields: {
              text_message: this.user.text_message,
            },
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((res) => {
            console.log(res);
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          });
      } else if (role_id == 1) {
        this.setSettingsTextMessage(this.settings.text_message);
        this.$axios
          .post("/settings/update-fields", {
            fields: {
              default_text_message: this.settings.default_text_message,
            },
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((res) => {
            console.log(res);
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          });
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      settings: "settings/settings",
    }),
  },
};
</script>

<style>
</style>